// Datas típicas da rede. O sistema não cadastra o calendário de bimestres,
// então estas só pré-preenchem a exportação — a pessoa ajusta antes de gerar.
export const BIMESTRES_PADRAO = [
  { numero: 1, inicio: '02-01', fim: '04-15' },
  { numero: 2, inicio: '04-16', fim: '07-15' },
  { numero: 3, inicio: '08-01', fim: '09-30' },
  { numero: 4, inicio: '10-01', fim: '12-20' },
];

export function periodoDoBimestre(numero, ano) {
  const b = BIMESTRES_PADRAO.find((x) => x.numero === Number(numero));
  if (!b) return null;
  return { inicio: `${ano}-${b.inicio}`, fim: `${ano}-${b.fim}` };
}

/** Bimestre em que a data (AAAA-MM-DD) cai; fora de todos, o último que já começou. */
export function bimestreDaData(data) {
  const mmdd = String(data).slice(5, 10);
  let atual = 1;
  BIMESTRES_PADRAO.forEach((b) => {
    if (mmdd >= b.inicio) atual = b.numero;
  });
  return atual;
}

export function ultimoDiaDoMes(ano, mes) {
  const dia = new Date(Number(ano), Number(mes), 0).getDate();
  return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
}
